<div class="member-link-source" [class.member-link-source--manual]="!isSystemMember">
  <mat-icon>{{ isSystemMember ? 'verified_user' : 'edit_note' }}</mat-icon>
  <span>{{ isSystemMember ? 'Miembro registrado' : 'Nombre ingresado manualmente' }}</span>
</div>
